<form
  *ngIf="(state$ | async)?.form as form"
  [formGroup]="form"
  class="form">
  <mat-form-field>
    <input
      matInput
      formControlName="name"
      [placeholder]="'Nome' | translate">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'Tipo' | translate }}</mat-label>
    <mat-select formControlName="ext">
      <mat-option></mat-option>
      <mat-option [value]="'jpg'">Immagine</mat-option>
      <mat-option [value]="'pdf'">PDF</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="tags"
      [placeholder]="'Tag' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="note"
      [placeholder]="'Note' | translate">
  </mat-form-field>
</form>
